module.exports = "<p>\r\n    Did you mean <a href=\"{{generateUrl()}}\" (click)=\"handleSuggestedWorClick()\">{{suggestedWord}}</a>?\r\n</p>\r\n"